import { TFundingRequirementType } from '@helpers/FundingRequirements/fundingRequirements.types';

export const FUNDING_REQUIREMENTS_LIST_PATH = '/funding-requirements/';

export const REQUIREMENT_STEP_PATHS = {
    bank_details: `${FUNDING_REQUIREMENTS_LIST_PATH}bank-details`,
    id_verification: `${FUNDING_REQUIREMENTS_LIST_PATH}id-check`,
    upload_gewerbeschein: `${FUNDING_REQUIREMENTS_LIST_PATH}upload-gewerbeschein`,
    credit_agreement: `${FUNDING_REQUIREMENTS_LIST_PATH}sign-credit-agreement`,
    personal_guarantee: `${FUNDING_REQUIREMENTS_LIST_PATH}sign-personal-guarantee`,
    upload_bank_evidence: `${FUNDING_REQUIREMENTS_LIST_PATH}upload-bank-evidence`,
    applicant_call: `${FUNDING_REQUIREMENTS_LIST_PATH}applicant-call`
} satisfies Record<TFundingRequirementType, string>;
